
// const icreditHost_s = 'http://81.218.62.41:443'

export const keys_strings = {
    // payment page identifier
    icredit_groupPrivateTokenTest: "689552db-54b5-4c74-9f1c-9dd6188a10b1",
    icredit_groupPrivateToken_iw_withId: "d648b090-8b7e-47e8-a01d-cca55a4094ca",
    icredit_groupPrivateToken_iw_noId: "06930e4f-7775-4c6d-940c-e23303a57157",
    icredit_groupPrivateToken_en_withId: "822d84c8-bd39-4ccf-97f2-fe2a78c71d5d",
    icredit_groupPrivateToken_en_noId: "43d021af-e740-494d-b119-8f9c0f52be3e",

    icredit_creditboxTokenTest: "d27a5712-53a5-4543-bf3e-7a3c16164ff8",
    icredit_creditboxToken: "34e94f0c-3cdf-478f-b890-e3689e1feed8",
    icredit_creditboxToken_withReceipt: "d9e05f41-f579-48a8-84bc-6b3bd5cd0e7e",
    icredit_creditboxToken_withReceipt2: "08e49ca0-b931-49cf-8949-450d7f498529", // receive this number for createSale
    icredit_apiToket: "017B563A-7F30-4282-B7C0-7D38C3B77C70", // not sure for what

    url_chargeSimpleTest: 'https://testpci.rivhit.co.il/api/iCreditRestApiService.svc/ChargeSimple',
    url_getUrlTest: 'https://testicredit.rivhit.co.il/API/PaymentPageRequest.svc/GetUrl',
    url_verifyTest: 'https://testicredit.rivhit.co.il/API/PaymentPageRequest.svc/Verify',
    url_SaleChargeTokenTest: 'https://testicredit.rivhit.co.il/API/PaymentPageRequest.svc/SaleChargeToken',

    url_getUrl              : 'https://icredit.rivhit.co.il/API/PaymentPageRequest.svc/GetUrl',
    url_SaleChargeToken     : 'https://icredit.rivhit.co.il/API/PaymentPageRequest.svc/SaleChargeToken',
    url_createSale          : 'https://icredit.rivhit.co.il/API/PaymentPageRequest.svc/CreateSale',
    url_chargeSimple        : 'https://pci.rivhit.co.il/api/iCreditRestApiService.svc/ChargeSimple',
    url_verify              : 'https://icredit.rivhit.co.il/API/PaymentPageRequest.svc/Verify',
    url_completeSale        : 'https://icredit.rivhit.co.il/API/PaymentPageRequest.svc/CompleteSale',
    url_chargePendingSale   : 'https://icredit.rivhit.co.il/API/PaymentPageRequest.svc/ChargePendingSale',

    sendGrid_key: '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',
    email_info: 'info@travelandquest.com',
    email_doNotReply: 'doNotReply@travelandquest.com',
    email_admin: 'dan@travelandquest.com',

    key: "MFswDQYJKoZIhvcNAQEBBQADSgAwRwJAaSHgOH+z5FjSE76LtAROOVZp/QlZHIDV5jtjblAJt+qcW9g6jUtghESlEsnpV5goFPZT4edh+0R6dlFm9xSLsQIDAQAB"
}


